// import daterangepicker from 'daterangepicker';
// import select2 from 'select2';

export default class InitializeForm {
    initialize() {
        this.liveWire();
        this.initializeDatePickers();
        this.initializeTypeToSearch();
        this.initializeWYSIWYG();
        this.addEvents();
    }

    liveWire() {
        Livewire.on('reInitializeForm', event => {
            this.initializeDatePickers();
            this.initializeTypeToSearch();
            this.initializeWYSIWYG();
        });

        Livewire.on('manageHideProfileForm', mentor_status => {
            var hide_profile_form = $('#hide-profile-form');

            if (mentor_status == 'yes') {
                hide_profile_form.removeClass('d-none');
            }
            else {
                hide_profile_form.addClass('d-none');
            }
        });

        Livewire.on('closeModal', modal_name => {
            $(`#${modal_name}`).modal('hide');
            $('.modal-backdrop.fade.show').remove();
            $('body.modal-open').removeClass('modal-open');
        });

        Livewire.on('scrollPage', item_to_scroll => {
            var scroll_top_value = 0;

            if (item_to_scroll) {
                // Scroll to a specific spot
                scroll_top_value = $(item_to_scroll).offset().top;
            }

            $('html, body').animate({
                scrollTop: scroll_top_value
            }, 1000);
        });

        Livewire.on('showUpdatedMessage', event => {
            setTimeout(function() {
                Livewire.emit('hideUpdatedMessage');
            }, 1000);
        });

        // Replace the already rendered avatar with the updated one once the avatar selection is made
        Livewire.on('refreshAvatar', data => {
            const target = $('.avatar-greetings a > img');
            $(target).attr("src", data['updated_avatar']);
        });

        Livewire.on('setLivewireDatepicker', settings => {
            $(`#${settings['input_name']}`).val(settings['value']);
			// $('.js-datepicker[model_name="' +  settings['input_name'] + '"]').val(settings['value']);
		});
    }

    initializeDatePickers() {
        // Options can be found here:
        // https://www.daterangepicker.com/#options

        $('.datepicker').each(function () {
            var this_input = $(this);
            this_input.daterangepicker({
                opens: 'right',
                timePicker: false,
                autoApply: true,
                autoUpdateInput: false,
                singleDatePicker: true,
                locale: {
                    direction: 'ltr',
                    format: 'YYYY-MM-DD',
                    separator: ' - ',
                    customRangeLabel: 'Custom',
                    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    firstDay: 1
                },
            },
                function (chosen_date) {
                    this_input.val(chosen_date.format('YYYY-MM-DD'));
                })
                .on('apply.daterangepicker', function(e, picker) {
                    var new_value = e.target.value;
                    var input_name = e.target.name;

                    console.log(input_name, e.target.wire_model);
    
                    Livewire.emit('jsInputChanged', new_value, input_name);
                });
        });

        $('.input-daterange').each(function () {
            var this_input = $(this);
            this_input.datepicker({
                format: 'yyyy-mm-dd',
            }).on('changeDate', function (e) {
                var new_value = e.target.value;
                var input_name = e.target.name;

                Livewire.emit('jsInputChanged', new_value, input_name);
            });
        });

        $('.admin-datepicker').each(function () {
            var this_input = $(this);
            this_input.datepicker({
                format: 'yyyy-mm-dd',
                autoclose: true,
                immediateUpdates: true,
            }).on('changeDate', function (e) {
                var new_value = e.target.value;
                var input_name = this_input.attr('name');

                Livewire.emit('jsInputChanged', new_value, input_name);
            });
        });
    }

    initializeTypeToSearch() {
        var placeholders = {
            'en': 'Type to search',
            'fr': 'Tapez le critère de recherche'
        };

        // app_locale is globally set in front_end.blade.php
        let placeholder = (placeholders.hasOwnProperty(app_locale)) ? placeholders[app_locale] : placeholders['en'];

        // DEFAULT
        $('.type-to-search').each(function () {
            var this_input      = $(this); if ( this_input.length == 0 ) return;
            var select2_options = { placeholder: placeholder };

            switch( this_input[0].id ) {
                case 'user_avatar':
                    // we want to hide the search box for Avatar Selection
                    select2_options = { minimumResultsForSearch: Infinity }
                    break;
            }
            this_input.select2(select2_options);
        });

        // TAGS
        $('.type-to-search-custom-tags').each(function () {
            var this_input = $(this);
            this_input.select2({
                placeholder: placeholder,
                tags: true,
            });
        });

        // SINGLE
        $('.type-to-search-single').each(function () {
            var this_input = $(this);
            this_input.select2({
                placeholder: placeholder,
                allowClear: true,
            });
        });
    }

    addEvents() {
        // Daterangepickers
        $('body').on('apply.daterangepicker', '.datepicker', function (e) {
            var new_value = e.target.value;
            var input_name = $(this).attr('name');

            Livewire.emit('jsInputChanged', new_value, input_name);
        });

        // Default Select2
        $('body').on('select2:select select2:unselect', '.type-to-search', function ($event) {
            var _this = $(this);
            var new_value = _this.val();
            var input_name = _this.attr('name');

            Livewire.emit('jsInputChanged', new_value, input_name);

            // Check whether to manually trigger an event because select2 is dumb
            // Events can only have a name, no custom variables
            var livewire_event = _this.attr('wire:change');
            if (livewire_event != null || livewire_event != '') {
                // Manually emit the event because select2 is dumb
                livewire_event = livewire_event.substring(
                    livewire_event.lastIndexOf('("') + 2,
                    livewire_event.lastIndexOf('",')
                );

                Livewire.emit(livewire_event, new_value);
            }
        });

        $('body').on('select2:select select2:unselect', '.type-to-search-single', function (e) {
            var _this = $(this);
            var new_value =  _this.val();
            var input_name = _this.attr('name');

            Livewire.emit('jsInputChanged', new_value, input_name);

            // Check whether to manually trigger an event because select2 is dumb
            // Events can only have a name, no custom variables
            var livewire_event = _this.attr('wire:change');
            if (livewire_event != null || livewire_event != '') {
                // Manually emit the event because select2 is dumb
                livewire_event = livewire_event.substring(
                    livewire_event.lastIndexOf('("') + 2,
                    livewire_event.lastIndexOf('",')
                );

                Livewire.emit(livewire_event, new_value);
            }
        });

        $('body').on('select2:select select2:unselect', '.type-to-search-custom-tags', function (e) {
            var _this = $(this);
            var new_value = _this.val();
            var input_name = _this.attr('name');
            var field_name = _this.attr('data-field-name');

            Livewire.emit('customTagsChanged', new_value, field_name, input_name);

            // Check whether to manually trigger an event because select2 is dumb
            // Events can only have a name, no custom variables
            var livewire_event = _this.attr('wire:change');
            if (livewire_event != null && livewire_event != '') {
                // Manually emit the event because select2 is dumb
                livewire_event = livewire_event.substring(
                    livewire_event.lastIndexOf('("') + 2,
                    livewire_event.lastIndexOf('",')
                );

                Livewire.emit(livewire_event, new_value);
            }
        });
    }

    initializeWYSIWYG() {
		if (typeof(tinymce) == "undefined") { return; }

        // Clear the existing editors to allow LW to reload properly
        tinymce.remove(".tinymce-content-page");

        tinymce.init({
            branding: false,
            selector: '.tinymce-content-page',
            menubar: false,
            plugins: 'autoresize advlist autolink link lists code',
            toolbar: 'styleselect | bold italic | bullist | link | code removeformat',
            style_formats: [
                { title: 'Headings' },
                { title: 'Page Title', block: 'h2' },
                { title: 'Title', block: 'h5' },
                { title: 'Subhead', block: 'h6' },
                { title: 'Text' },
                { title: 'Paragraph', block: 'p' },
            ],
            width: '100%',
            height: 400,
            min_height: 300,
            max_height: 600,
			init_instance_callback: function(editor) {
				// Make Livewire listen
				editor.on('blur', function(e) {
					var wire_name = $(`#${editor.id}`).attr('wire:model');
					Livewire.emit('jsInputChanged', editor.getContent(), wire_name);
				});
			}
        });
    }

}